import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
var _class;
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
var CommonError = /*#__PURE__*/function (_Error) {
  _inherits(CommonError, _Error);
  var _super = _createSuper(CommonError);
  function CommonError(message) {
    var _this;
    _classCallCheck(this, CommonError);
    _this = _super.call(this, message);
    _this.name = _this.constructor.name;
    _this.message = message;
    _this.stack = new Error(message).stack || '';
    return _this;
  }
  return _createClass(CommonError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var DefaultError = /*#__PURE__*/function (_CommonError) {
  _inherits(DefaultError, _CommonError);
  var _super2 = _createSuper(DefaultError);
  function DefaultError(_ref) {
    var _this2;
    var message = _ref.message;
    _classCallCheck(this, DefaultError);
    _this2 = _super2.call(this, message || 'UnknownError');
    Object.setPrototypeOf(_assertThisInitialized(_this2), DefaultError.prototype);
    return _this2;
  }
  return _createClass(DefaultError);
}(CommonError);
export var SentryIgnoreError = /*#__PURE__*/function (_CommonError2) {
  _inherits(SentryIgnoreError, _CommonError2);
  var _super3 = _createSuper(SentryIgnoreError);
  function SentryIgnoreError(_ref2) {
    var _this3;
    var message = _ref2.message;
    _classCallCheck(this, SentryIgnoreError);
    _this3 = _super3.call(this, "SentryIgnore: ".concat(message || 'UnknownError'));
    Object.setPrototypeOf(_assertThisInitialized(_this3), SentryIgnoreError.prototype);
    return _this3;
  }
  return _createClass(SentryIgnoreError);
}(CommonError);

// Http Errors
export var HttpError = /*#__PURE__*/function (_CommonError3) {
  _inherits(HttpError, _CommonError3);
  var _super4 = _createSuper(HttpError);
  function HttpError(_ref3) {
    var _this4;
    var message = _ref3.message,
      status = _ref3.status;
    _classCallCheck(this, HttpError);
    _this4 = _super4.call(this, message);
    Object.setPrototypeOf(_assertThisInitialized(_this4), HttpError.prototype);
    _this4.status = status;
    return _this4;
  }
  return _createClass(HttpError);
}(CommonError);

// Graphql Errors

export var GraphQLError = /*#__PURE__*/function (_CommonError4) {
  _inherits(GraphQLError, _CommonError4);
  var _super5 = _createSuper(GraphQLError);
  // tslint:disable-line no-any

  function GraphQLError(_ref4) {
    var _this5;
    var _ref4$message = _ref4.message,
      message = _ref4$message === void 0 ? 'unknown' : _ref4$message,
      _ref4$category = _ref4.category,
      category = _ref4$category === void 0 ? 'default' : _ref4$category,
      fields = _ref4.fields;
    _classCallCheck(this, GraphQLError);
    _this5 = _super5.call(this, message);
    Object.setPrototypeOf(_assertThisInitialized(_this5), GraphQLError.prototype);
    _this5.category = category;
    if (fields) {
      _this5.fields = fields;
    }
    return _this5;
  }
  return _createClass(GraphQLError);
}(CommonError);
_class = GraphQLError;
_defineProperty(GraphQLError, "from", function (rawErrors) {
  var firstError = rawErrors[0];
  var errorData = {
    category: firstError.category,
    message: firstError.message
  };
  if (firstError.fields) {
    errorData.fields = firstError.fields.reduce(function (obj, item) {
      obj[item.field] = item.message;
      return obj;
    }, {});
  }
  return new _class(errorData);
});